export const PC_PAGE_CONFIG = {
  "title": "Country Comparison",
  "titleCN": "国家对比",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/comparisonAnalysis/countryComparison",
  "tabList": [
    {
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/countryComparison",
      "path": "/comparisonAnalysis/countryComparison",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "201601",
        "pageName": "comparisonAnalysisCountryComparison",
        "extInfo": "comparisonAnalysisCountryComparison",
        "pagePath": "/comparisonAnalysis/countryComparison",
        "typeId": "dashboard_pc_v2"
      },
      "filters": [
        {
          "name": "CountryComparisonFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/countryComparison",
          "data": {
            "typeList": [
              "date"
            ]
          },
          "componentList": [
            {
              "name": "CountryComparisonService",
              "className": "",
              "type": "view",
              "style": {},
              "data": {
                "metric": "new_users"
              },
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/comparison_analysis/country/linechart",
                  "isDark": true,
                  "dataKey": "country_line_chart",
                  "initMetric": "new_users"
                }
              },
              "children": [
                {
                  "name": "SegmentTabsCo",
                  "props": {
                    "config": {
                      "dataKey": "metric",
                      "tabList": {
                        "Day": [
                          {
                            "id": "TRU",
                            "indicatorsName": "tnu",
                            "resName": "total_users",
                            "resAvgName": "",
                            "name": "TNU",
                            "nameCn": "总注册用户数",
                            "rainbowKey": "Pc TNU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "New",
                            "indicatorsName": "new",
                            "resName": "new_users",
                            "resAvgName": "",
                            "name": "New",
                            "nameCn": "新进用户",
                            "rainbowKey": "Pc New",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "DAU",
                            "indicatorsName": "dau",
                            "resName": "active_users",
                            "resAvgName": "",
                            "name": "DAU",
                            "nameCn": "日活跃",
                            "rainbowKey": "Pc DAU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Revenue",
                            "indicatorsName": "net_revenue",
                            "resName": "net_revenue",
                            "resAvgName": "",
                            "name": "Revenue After Refund & Tax($)",
                            "nameCn": "净收入($)",
                            "rainbowKey": "Pc Revenue",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "RevenueAfter",
                            "indicatorsName": "revenue_after_chargeback",
                            "resName": "revenue_after_chargeback",
                            "resAvgName": "",
                            "name": "Revenue After Refund($)",
                            "nameCn": "收入(剔除退款)($)",
                            "rainbowKey": "Pc Revenue After Refund($)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Units",
                            "indicatorsName": "units_number",
                            "resName": "units_number",
                            "resAvgName": "",
                            "name": "Base Game Units After Refund",
                            "nameCn": "本体拷贝净销量",
                            "rainbowKey": "Pc Units",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Gross Revenue",
                            "indicatorsName": "gross_revenue",
                            "resName": "gross_revenue",
                            "resAvgName": "",
                            "name": "Revenue($)",
                            "nameCn": "收入($)",
                            "rainbowKey": "Pc Gross Revenue",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Units Revenue",
                            "indicatorsName": "units_revenue",
                            "resName": "units_revenue",
                            "resAvgName": "",
                            "name": "Base Game Revenue After Refund & Tax",
                            "nameCn": "本体拷贝收入",
                            "rainbowKey": "Pc Units Revenue",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "In-Game Revenue",
                            "indicatorsName": "mtx_revenue",
                            "resName": "mtx_revenue",
                            "resAvgName": "",
                            "name": "In-Game Revenue",
                            "nameCn": "内购收入",
                            "rainbowKey": "Pc In-Game Revenue",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "In-Game Payer",
                            "indicatorsName": "mtx_payers",
                            "resName": "mtx_payers",
                            "resAvgName": "",
                            "name": "In-Game Payer",
                            "nameCn": "内购付费人数",
                            "rainbowKey": "Pc In-Game Payer",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "In-Game Payer%",
                            "indicatorsName": "mtx_payer_rate",
                            "resName": "mtx_payer_rate",
                            "resAvgName": "",
                            "name": "In-Game Payer%",
                            "nameCn": "内购付费渗透率",
                            "rainbowKey": "Pc In-Game Payer%",
                            "isPercent": true,
                            "decimals": 2,
                            "dodDecimals": 1,
                            "avgName": "",
                            "isUserType": false
                          },
                          {
                            "id": "In-Game ARPU",
                            "indicatorsName": "mtx_arpu",
                            "resName": "mtx_arpu",
                            "resAvgName": "",
                            "name": "In-Game ARPU",
                            "nameCn": "内购ARPU",
                            "rainbowKey": "Pc In-Game ARPU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "In-Game ARPPU",
                            "indicatorsName": "mtx_arppu",
                            "resName": "mtx_arppu",
                            "resAvgName": "",
                            "name": "In-Game ARPPU",
                            "nameCn": "内购付费ARPPU",
                            "rainbowKey": "Pc In-Game ARPPU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D1",
                            "indicatorsName": "d1",
                            "resName": "d1",
                            "resAvgName": "",
                            "name": "D1",
                            "nameCn": "D1留存",
                            "rainbowKey": "Pc D1",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D2",
                            "indicatorsName": "d2",
                            "resName": "d2",
                            "resAvgName": "",
                            "name": "D2",
                            "nameCn": "D2留存",
                            "rainbowKey": "Pc D2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D3",
                            "indicatorsName": "d3",
                            "resName": "d3",
                            "resAvgName": "",
                            "name": "D3",
                            "nameCn": "D3留存",
                            "rainbowKey": "Pc D3",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D4",
                            "indicatorsName": "d4",
                            "resName": "d4",
                            "resAvgName": "",
                            "name": "D4",
                            "nameCn": "D4留存",
                            "rainbowKey": "Pc D4",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D5",
                            "indicatorsName": "d5",
                            "resName": "d5",
                            "resAvgName": "",
                            "name": "D5",
                            "nameCn": "D5留存",
                            "rainbowKey": "Pc D5",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D6",
                            "indicatorsName": "d6",
                            "resName": "d6",
                            "resAvgName": "",
                            "name": "D6",
                            "nameCn": "D6留存",
                            "rainbowKey": "Pc D6",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D7",
                            "indicatorsName": "d7",
                            "resName": "d7",
                            "resAvgName": "",
                            "name": "D7",
                            "nameCn": "D7留存",
                            "rainbowKey": "Pc D7",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D14",
                            "indicatorsName": "d14",
                            "resName": "d14",
                            "resAvgName": "",
                            "name": "D14",
                            "nameCn": "D14留存",
                            "rainbowKey": "Pc D14",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "D30",
                            "indicatorsName": "d30",
                            "resName": "d30",
                            "resAvgName": "",
                            "name": "D30",
                            "nameCn": "D30留存",
                            "rainbowKey": "Pc D30",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "PCU",
                            "indicatorsName": "pcu",
                            "resName": "pcu",
                            "resAvgName": "",
                            "name": "PCU",
                            "nameCn": "最高同时在线",
                            "rainbowKey": "PCU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "ACU",
                            "indicatorsName": "acu",
                            "resName": "acu",
                            "resAvgName": "",
                            "name": "ACU",
                            "nameCn": "平均同时在线",
                            "rainbowKey": "ACU",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Avg.Playtime(h)",
                            "indicatorsName": "aot_hour",
                            "resName": "aot_hour",
                            "resAvgName": "",
                            "name": "Avg.Playtime(h)",
                            "nameCn": "平均在线时长(小时)",
                            "rainbowKey": "Pc Avg.Playtime(h)",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Sessions per user",
                            "indicatorsName": "alc",
                            "resName": "alc",
                            "resAvgName": "",
                            "name": "Sessions per user",
                            "nameCn": "平均登录次数",
                            "rainbowKey": "Sessions per user",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "DAU Retention Users",
                            "indicatorsName": "retention_users",
                            "resName": "retention_users",
                            "resAvgName": "",
                            "name": "DAU Retention Users",
                            "nameCn": "日活留存",
                            "rainbowKey": "DAU Retention Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Churn Users",
                            "indicatorsName": "churn_users",
                            "resName": "churn_users",
                            "resAvgName": "",
                            "name": "Churn Users",
                            "nameCn": "日流失",
                            "rainbowKey": "Churn Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Churn%",
                            "indicatorsName": "churn_rate",
                            "resName": "churn_rate",
                            "resAvgName": "",
                            "name": "Churn%",
                            "nameCn": "流失率",
                            "rainbowKey": "Churn%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "DAU Return Users",
                            "indicatorsName": "return_users",
                            "resName": "return_users",
                            "resAvgName": "",
                            "name": "DAU Return Users",
                            "nameCn": "日回流",
                            "rainbowKey": "DAU Return Users",
                            "avgName": "",
                            "isPercent": false,
                            "decimals": 0,
                            "isUserType": true,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Weighted D2",
                            "indicatorsName": "weighted_d2",
                            "resName": "weighted_d2",
                            "resAvgName": "",
                            "name": "Weighted D1",
                            "nameCn": "加权D1留存",
                            "rainbowKey": "Weighted D1",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Weighted D3",
                            "indicatorsName": "weighted_d3",
                            "resName": "weighted_d3",
                            "resAvgName": "",
                            "name": "Weighted D2",
                            "nameCn": "加权D2留存",
                            "rainbowKey": "Weighted D2",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Weighted D7",
                            "indicatorsName": "weighted_d7",
                            "resName": "weighted_d7",
                            "resAvgName": "",
                            "name": "Weighted D6",
                            "nameCn": "加权D6留存",
                            "rainbowKey": "Weighted D6",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "Weighted D14",
                            "indicatorsName": "weighted_d14",
                            "resName": "weighted_d14",
                            "resAvgName": "",
                            "name": "Weighted D13",
                            "nameCn": "加权D13留存",
                            "rainbowKey": "Weighted D13",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "1st Order Login%",
                            "indicatorsName": "first_login_ratio",
                            "resName": "first_login_ratio",
                            "resAvgName": "",
                            "name": "1st Order Login%",
                            "nameCn": "一阶登录比",
                            "rainbowKey": "1st Order Login%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          },
                          {
                            "id": "2nd Order Login%",
                            "indicatorsName": "second_login_ratio",
                            "resName": "second_login_ratio",
                            "resAvgName": "",
                            "name": "2nd Order Login%",
                            "nameCn": "二阶登录比",
                            "rainbowKey": "2nd Order Login%",
                            "avgName": "",
                            "isPercent": true,
                            "decimals": 2,
                            "isUserType": false,
                            "dodDecimals": 1
                          }
                        ]
                      }
                    }
                  },
                  "children": [
                    {
                      "name": "CountryComparisonChart"
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverallTableCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "lockColumns": [
                    {
                      "key": "date",
                      "lockRainbowKey": "Pc Lock Date Tip",
                      "unlockRainbowKey": "Pc Unlock Date Tip",
                      "showDimList": [
                        "date"
                      ]
                    }
                  ],
                  "isUseNewSortParams": true,
                  "isHaveDiff": false,
                  "useTime": true,
                  "showStatistic": [
                    "sum",
                    "avg_no_null"
                  ],
                  "slotConfig": {
                    "isShowdownloadConfig": false
                  },
                  "valueTypeConfig": {
                    "valueType": "value_only",
                    "isShowChange": false
                  },
                  "dimensionConfig": {
                    "dateDisabled": false,
                    "defaultAccumulation": [
                      "date",
                      "country"
                    ],
                    "isShowCountryFlag": true
                  },
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/comparison_analysis/country/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/comparison_analysis/country/overall_performance/download"
                  },
                  "titleEn": "Key Metrics Ranking",
                  "titleCn": "关键指标排名",
                  "componentMetricsConfig": {
                    "Day": [
                      {
                        "metricKey": "total_users",
                        "reqMetricKey": "total_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 105,
                        "cnWidth": 112,
                        "enName": "TNU",
                        "cnName": "总注册用户数",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1,
                        "enExplain": "Total New Users. Total number of registered users accumulated to the statistical day (userid deduplicated).",
                        "cnExplain": "累计至统计日的注册用户总数(userid数去重)。",
                        "rainbowKey": "TNU"
                      },
                      {
                        "metricKey": "new_users",
                        "reqMetricKey": "new_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "New",
                        "cnName": "新进用户",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1,
                        "enExplain": "",
                        "cnExplain": "",
                        "rainbowKey": "New"
                      },
                      {
                        "metricKey": "active_users",
                        "reqMetricKey": "active_users",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 85,
                        "cnWidth": 85,
                        "enName": "DAU",
                        "cnName": "日活跃",
                        "rainbowKey": "DAU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "net_revenue",
                        "reqMetricKey": "net_revenue",
                        "enPercentWidth": 270,
                        "cnPercentWidth": 190,
                        "enWidth": 270,
                        "cnWidth": 200,
                        "enName": "Revenue After Refund & Tax($)",
                        "cnName": "净收入($)",
                        "rainbowKey": "Pc Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "revenue_after_chargeback",
                        "reqMetricKey": "revenue_after_chargeback",
                        "enPercentWidth": 270,
                        "cnPercentWidth": 190,
                        "enWidth": 270,
                        "cnWidth": 200,
                        "enName": "Revenue After Refund($)",
                        "cnName": "收入(剔除退款)($)",
                        "rainbowKey": "Pc Revenue After Refund($)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "units_number",
                        "reqMetricKey": "units_number",
                        "enPercentWidth": 290,
                        "cnPercentWidth": 230,
                        "enWidth": 290,
                        "cnWidth": 155,
                        "enName": "Base Game Units After Refund",
                        "cnName": "本体拷贝净销量",
                        "rainbowKey": "Pc Units",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "gross_revenue",
                        "reqMetricKey": "gross_revenue",
                        "enPercentWidth": 210,
                        "cnPercentWidth": 160,
                        "enWidth": 160,
                        "cnWidth": 160,
                        "enName": "Revenue($)",
                        "cnName": "收入($)",
                        "rainbowKey": "Pc Gross Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "units_revenue",
                        "reqMetricKey": "units_revenue",
                        "enPercentWidth": 350,
                        "cnPercentWidth": 260,
                        "enWidth": 350,
                        "cnWidth": 185,
                        "enName": "Base Game Revenue After Refund & Tax",
                        "cnName": "本体拷贝收入",
                        "rainbowKey": "Pc Units Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_revenue",
                        "reqMetricKey": "mtx_revenue",
                        "enPercentWidth": 210,
                        "cnPercentWidth": 210,
                        "enWidth": 200,
                        "cnWidth": 112,
                        "enName": "In-Game Revenue",
                        "cnName": "内购收入",
                        "rainbowKey": "Pc In-Game Revenue",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payers",
                        "reqMetricKey": "mtx_payers",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 150,
                        "cnWidth": 112,
                        "enName": "In-Game Payer",
                        "cnName": "内购付费人数",
                        "rainbowKey": "Pc In-Game Payer",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_payer_rate",
                        "reqMetricKey": "mtx_payer_rate",
                        "enPercentWidth": 200,
                        "cnPercentWidth": 200,
                        "enWidth": 165,
                        "cnWidth": 150,
                        "enName": "In-Game Payer%",
                        "cnName": "内购付费渗透率",
                        "rainbowKey": "Pc In-Game Payer%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_arpu",
                        "reqMetricKey": "mtx_arpu",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 180,
                        "enWidth": 145,
                        "cnWidth": 112,
                        "enName": "In-Game ARPU",
                        "cnName": "内购ARPU",
                        "rainbowKey": "Pc In-Game ARPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "mtx_arppu",
                        "reqMetricKey": "mtx_arppu",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 155,
                        "cnWidth": 150,
                        "enName": "In-Game ARPPU",
                        "cnName": "内购付费ARPPU",
                        "rainbowKey": "Pc In-Game ARPPU",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "d1",
                        "reqMetricKey": "d1",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D1",
                        "cnName": "D1留存",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2,
                        "rainbowKey": "Pc D1"
                      },
                      {
                        "metricKey": "d2",
                        "reqMetricKey": "d2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D2",
                        "cnName": "D2留存",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2,
                        "rainbowKey": "Pc D2"
                      },
                      {
                        "metricKey": "d3",
                        "reqMetricKey": "d3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D3",
                        "cnName": "D3留存",
                        "rainbowKey": "D3",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d4",
                        "reqMetricKey": "d4",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D4",
                        "cnName": "D4留存",
                        "rainbowKey": "D4",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d5",
                        "reqMetricKey": "d5",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D5",
                        "cnName": "D5留存",
                        "rainbowKey": "D5",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d6",
                        "reqMetricKey": "d6",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D6",
                        "cnName": "D6留存",
                        "rainbowKey": "D6",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d7",
                        "reqMetricKey": "d7",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 80,
                        "enName": "D7",
                        "cnName": "D7留存",
                        "rainbowKey": "D7",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d14",
                        "reqMetricKey": "d14",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 100,
                        "enName": "D14",
                        "cnName": "D14留存",
                        "rainbowKey": "D14",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "d30",
                        "reqMetricKey": "d30",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 70,
                        "cnWidth": 100,
                        "enName": "D30",
                        "cnName": "D30留存",
                        "rainbowKey": "D30",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "pcu",
                        "reqMetricKey": "pcu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "PCU",
                        "cnName": "最高同时在线",
                        "rainbowKey": "PCU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "acu",
                        "reqMetricKey": "acu",
                        "enPercentWidth": 152,
                        "cnPercentWidth": 152,
                        "enWidth": 77,
                        "cnWidth": 112,
                        "enName": "ACU",
                        "cnName": "平均同时在线",
                        "rainbowKey": "ACU",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "aot_hour",
                        "reqMetricKey": "aot_hour",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 160,
                        "enWidth": 164,
                        "cnWidth": 190,
                        "enName": "Avg.Playtime(h)",
                        "cnName": "平均在线时长(小时)",
                        "rainbowKey": "Pc Avg.Playtime(h)",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "alc",
                        "reqMetricKey": "alc",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 140,
                        "enWidth": 160,
                        "cnWidth": 140,
                        "enName": "Sessions per user",
                        "cnName": "平均登录次数",
                        "rainbowKey": "Sessions per user",
                        "type": "decimals",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "retention_users",
                        "reqMetricKey": "retention_users",
                        "enPercentWidth": 190,
                        "cnPercentWidth": 190,
                        "enWidth": 200,
                        "cnWidth": 171,
                        "enName": "DAU Retention Users",
                        "cnName": "日活留存",
                        "rainbowKey": "DAU Retention Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_users",
                        "reqMetricKey": "churn_users",
                        "enPercentWidth": 170,
                        "cnPercentWidth": 170,
                        "enWidth": 114,
                        "cnWidth": 95,
                        "enName": "Churn Users",
                        "cnName": "日流失",
                        "rainbowKey": "Churn Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "churn_rate",
                        "reqMetricKey": "churn_rate",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 80,
                        "cnWidth": 64,
                        "enName": "Churn%",
                        "cnName": "流失率",
                        "rainbowKey": "Churn%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "return_users",
                        "reqMetricKey": "return_users",
                        "enPercentWidth": 180,
                        "cnPercentWidth": 170,
                        "enWidth": 170,
                        "cnWidth": 95,
                        "enName": "DAU Return Users",
                        "cnName": "日回流",
                        "rainbowKey": "DAU Return Users",
                        "type": "int",
                        "decimal": 0,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d2",
                        "reqMetricKey": "weighted_d2",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 122,
                        "enName": "Weighted D1",
                        "cnName": "加权D1留存",
                        "rainbowKey": "Weighted D1",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 2
                      },
                      {
                        "metricKey": "weighted_d3",
                        "reqMetricKey": "weighted_d3",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 122,
                        "enName": "Weighted D2",
                        "cnName": "加权D2留存",
                        "rainbowKey": "Weighted D2",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d7",
                        "reqMetricKey": "weighted_d7",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 122,
                        "cnWidth": 122,
                        "enName": "Weighted D6",
                        "cnName": "加权D6留存",
                        "rainbowKey": "Weighted D6",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "weighted_d14",
                        "reqMetricKey": "weighted_d14",
                        "enPercentWidth": 145,
                        "cnPercentWidth": 145,
                        "enWidth": 132,
                        "cnWidth": 132,
                        "enName": "Weighted D13",
                        "cnName": "加权D13留存",
                        "rainbowKey": "Weighted D13",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "first_login_ratio",
                        "reqMetricKey": "first_login_ratio",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 145,
                        "enWidth": 160,
                        "cnWidth": 145,
                        "enName": "1st Order Login%",
                        "cnName": "一阶登录比",
                        "rainbowKey": "1st Order Login%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      },
                      {
                        "metricKey": "second_login_ratio",
                        "reqMetricKey": "second_login_ratio",
                        "enPercentWidth": 160,
                        "cnPercentWidth": 145,
                        "enWidth": 160,
                        "cnWidth": 145,
                        "enName": "2nd Order Login%",
                        "cnName": "二阶登录比",
                        "rainbowKey": "2nd Order Login%",
                        "type": "percent",
                        "decimal": 2,
                        "percentDecimals": 1
                      }
                    ]
                  }
                }
              }
            }
          ]
        }
      ]
    }
  ]
};